// extracted by mini-css-extract-plugin
export default {"heading":"performanceManagement_heading__IRUBZ","gaugeBackground":"performanceManagement_gaugeBackground__5gFK2"};